import React from 'react';
import { Translate } from '../../../../../language';
import ImageNameDescription from '../../../../../utils/components/ImageNameDescription/ImageNameDescription';
import Options from '../../../../../utils/components/Options/Options';
import localStorage from '../../../../../utils/hooks/useLocalStorage';
import style from './AdminRoom.module.css'
const AdminRoomMembers = ({ kick,addMod,removeMod, members, roomInfo }) => {
    return (
        <div className={style.content_right_container}>
            <div className={style.title}>
                Miembros
            </div>
            <div className={style.list_item}>
                {members.map(member => {
                    let src = null
                    let id = null;
                    let name = null
                    let lastname = null
                    if (member.memberType ==="user") {
                        id = member.memberUserId._id
                        name = member.memberUserId.name
                        lastname = member.memberUserId.lastname
                        src = member.memberUserId.picture && member.memberUserId.picture.url && member.memberUserId.picture.url.small
                    }
                    if (member.memberType ==="franchise") {
                        id = member.memberFranchiseId._id
                        name = member.memberFranchiseId.socialReason
                        src = member.memberFranchiseId.picture && member.memberFranchiseId.picture.url && member.memberFranchiseId.picture.url.small
                    }
                    if (member.memberType ==="representative") {
                        id = member.memberRepresentativeId._id
                        name = member.memberRepresentativeId.userID.name
                        lastname = member.memberRepresentativeId.userID.lastname
                        src = member.memberRepresentativeId.userID.picture &&
                            member.memberRepresentativeId.userID.picture.url &&
                            member.memberRepresentativeId.userID.picture.url.small
                    }
                    if (member.memberType ==="warehouse") {
                        id = member.memberWarehouseId._id
                        name = member.memberWarehouseId.name
                        src = member.memberWarehouseId.profileId.picture &&
                            member.memberWarehouseId.profileId.picture.url &&
                            member.memberWarehouseId.profileId.picture.url.small
                    }
                    return (
                        <div>
                            <ImageNameDescription
                                type={"header-message"}
                                srcImage={src}
                                firstName={name}
                                secondName={lastname}
                                typeOneText="purple"
                                description={ member.adminID === member.entityID ? "Administrador" : roomInfo.moderatorId === member.entityID  && "Moderador" }

                                options={[

                                    member.adminID !== member.entityID && {
                                        text: Translate('kick', 'es'), onClick: (e) => {
                                            e.preventDefault(); e.stopPropagation();
                                            kick(member)
                                        }
                                    },
                                       (roomInfo.adminID !== member.entityID && roomInfo.moderatorId !== member.entityID && roomInfo.adminID === localStorage().getItem("idProfile")  )  && {
                                          text: Translate('modAdd', 'es'), onClick: (e) => {
                                              e.preventDefault(); e.stopPropagation();
                                              addMod(member)
                                          }
                                      },
                                      (roomInfo.adminID !== member.entityID && roomInfo.moderatorId === member.entityID && roomInfo.adminID === localStorage().getItem("idProfile") )&& {
                                          text: Translate('modRemove', 'es'), onClick: (e) => {
                                              e.preventDefault(); e.stopPropagation();
                                              removeMod(member)
                                          }
                                      }, 
                                ].filter(opt => typeof opt != "boolean")
                                }

                            />

                        </div>
                    )
                }
                )}
            </div>
        </div>
    )
};

export default AdminRoomMembers;
